import { Component, EventEmitter, Output } from '@angular/core'
import { MessageService } from 'primeng/api'

import { ApiPaymentBatchService } from '@modules/private/payment/data/services/api/api-payment-batch.service'
import { PaymentBatchStateService } from '@modules/private/payment/data/services/view/payment-batch-state.service'
import { FileService } from '@data/services/utils/file.service'

/**
 * Paso 1 · El archivo.
 *
 * Elegir la hoja y leerla. **Leerla no registra nada**: el operador puede corregir su archivo y
 * volver a subirlo tantas veces como haga falta sin que exista un solo pago.
 */
@Component({
	selector: 'app-step1-archivo',
	templateUrl: './step1-archivo.component.html',
	styleUrls: ['./step1-archivo.component.scss'],
})
export class Step1ArchivoComponent {
	@Output() onDone = new EventEmitter<void>()
	/** Cerrar el asistente desde la barra de acciones, no solo desde la X de la cabecera. */
	@Output() onExit = new EventEmitter<void>()

	file: File | null = null
	reading = false
	downloading = false
	error = ''

	constructor(
		public readonly state: PaymentBatchStateService,
		private readonly api: ApiPaymentBatchService,
		private readonly fileService: FileService,
		private readonly messageService: MessageService
	) {
		this.file = state.file
	}

	/**
	 * Elegir el archivo YA lo lee. No hay botón de «Leer archivo».
	 *
	 * Era un clic que nunca tenía otra respuesta posible: quien acaba de elegir una hoja quiere verla.
	 * Leerla no registra nada —el punto de no retorno está tres pasos más adelante—, así que no hay
	 * nada que confirmar aquí; si algo viene mal, se corrige el archivo y se vuelve a elegir.
	 */
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement
		if (!input.files?.length) return

		this.file = input.files[0]
		this.error = ''
		//* Se limpia el valor del input para que elegir el MISMO archivo otra vez vuelva a disparar el
		//* evento: si no, corregir la hoja y volver a seleccionarla no hace nada.
		input.value = ''
		this.leer()
	}

	leer(): void {
		const archivo = this.file
		if (!archivo || this.reading) return

		this.reading = true
		this.error = ''

		this.api.parse(archivo).subscribe((r) => {
			this.reading = false
			if (r.error || !r.data) {
				this.error = r.msg || 'No se pudo leer el archivo.'
				return
			}

			this.state.setParse(r.data, archivo)
			this.onDone.emit()
		})
	}

	descargarLayout(): void {
		this.downloading = true

		this.fileService.downloadFile('../../../../../assets/templates/layout_many_payments.xlsx').subscribe({
			next: (blob: Blob) => {
				const url = window.URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = url
				link.download = 'payments_layout.xlsx'
				link.click()
				window.URL.revokeObjectURL(url)
				this.downloading = false
			},
			error: () => {
				this.downloading = false
				this.messageService.add({ severity: 'error', summary: 'No se pudo descargar', detail: 'Vuelve a intentar; si se repite, repórtalo.' })
			},
		})
	}
}
